<div id="main" class="myw-content d-flex flex-column flex-fill" *ngIf="!hideCreateProp()">
    <div class="myw-inner myw-container">
        <h1 class="fs-20 text-primary my-4" *ngIf="!showHeaderB()">Create</h1>
        <h1 class="fs-20 text-primary my-4" *ngIf="showHeaderB()">Edit</h1>
        <form ngNativeValidate autocomplete="off" name="createproposalForm">
            <div class="iom-section iom-form">
                <div class="row">
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Client Name</label>
                            <span class="required-asterisk">*</span>
                            <input class="form-control" list="cname" placeholder="Search..." name="cname"
                                (change)="loadProjectDetails('cname')" [(ngModel)]="clientName" required />
                            <datalist id="cname">
                                <option *ngFor="let clientName of DistinctClientList" [value]="clientName">
                                    {{clientName}}</option>
                            </datalist>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">E2E Name</label>
                            <span class="required-asterisk">*</span>
                            <input class="form-control" placeholder="Search..." list="pname" name="pname"
                                (change)="loadMarketDetails('pname')" [(ngModel)]="projectName" required />
                            <datalist id="pname">
                                <option *ngFor="let ProjectName of MasterProjectDetails" [value]="ProjectName"> {{
                                    ProjectName }}
                                </option>
                            </datalist>
                        </div>                        
                    </div>
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Opportunity Id</label>
                            <span class="required-asterisk">*</span>
                            <input type="text" class="form-control" name="oppId" maxlength="30"
                                placeholder="Enter the Opportunity Id" [(ngModel)]="opportunityId" required />
                        </div>
                    </div>
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Market</label>
                            <!--<span class="required-asterisk">*</span>-->
                            <input class="form-control" list="mname" placeholder="Search..." name="market"
                                (change)="loadMarketUnitDetails('mname')" [(ngModel)]="market" required />
                            <datalist id="mname">
                                <option *ngFor="let market of MasterMarketList" [value]="market">{{market}}</option>
                            </datalist>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Market Unit</label>
                            <!--<span class="required-asterisk">*</span>-->
                            <input class="form-control" list="muname" placeholder="Search..." name="marketUnit"
                                (change)="loadClientGroup('muname')" [(ngModel)]="marketUnit" required />
                            <datalist id="muname">
                                <option *ngFor="let marketUnit of MasterMarketUnitList" [value]="marketUnit">
                                    {{marketUnit}}</option>
                            </datalist>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Client Group</label>
                            <!--<span class="required-asterisk">*</span>-->

                            <input class="form-control" list="cgname" placeholder="Search..." name="cgroup"
                                (change)="loadNothing('cgname')" [(ngModel)]="clientGroup" required />
                            <datalist id="cgname">
                                <option *ngFor="let clientGroup of MasterClientGroupList" [value]="clientGroup">
                                    {{clientGroup}}</option>
                            </datalist>
                        </div>
                    </div>
                    <div class="col-12" [ngClass]="{'disabled': !subscribed}">
                        <div [formGroup]="form1">
                            <label class="form-label">User Access (Enterprise ID)</label>
                            <div class="editor-tag">
                                <input placeholder="Add the user names and Use comma/enter for multiple users" #tagInput
                                    type="text" class="form-control input-tag" (keyup)="onKeyUp($event)"
                                    formControlName="tag" />
                                <small class="form-text text-muted">* Optional</small>
                            </div>
                            <div *ngIf="enableBox"
                                class="d-flex flex-wrap align-items-start border rounded pt-2 pb-3 px-3 mt-3">
                                <span class="tag-item iom-selected-item" *ngFor="let tag of tags" name="userAccess">
                                    {{tag}}
                                    <span class="remove-tag" (click)="removeTag(tag)" style="cursor: pointer;">×</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right my-4">
                <button type="button" class="btn btn-primary" (click)="CreateProposal()" *ngIf="!showHeaderB()">Create
                </button>
                <button type="button" class="btn btn-primary" (click)="CreateProposal()"
                    [ngClass]="{'disabled': !subscribed}" *ngIf="showHeaderB()">Create
                </button>
                <button type="button" style="width: 10%;margin-left: 20px;" class="btn btn-secondary"
                    (click)="navigateToProposalSummary()" *ngIf="showHeaderB() || isMandateCreate">Cancel</button>
            </div>
        </form>
    </div>
</div>